import { createContext, useContext } from "react";
import type { Session } from "./session";
export const SessionContext = createContext<Session | null>(null);
export function useSession() { return useContext(SessionContext); }
